import { useEffect, useState } from "react";
import { resolveDashboardGreeting, type DashboardGreeting } from "@/lib/dashboardGreeting";
import useUserTimezone from "@/hooks/useUserTimezone";

export default function useDashboardGreeting(): DashboardGreeting {
  const timeZone = useUserTimezone();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        setNow(new Date());
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  return resolveDashboardGreeting(now, timeZone);
}
